import { Box, Button, Checkbox, Grid, Modal, Typography } from '@mui/material';
import AppTextField from 'components/input-fields/AppTextField';
import { Camera, ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { ChevronLeft } from 'react-feather';

export default function CreateBoardModal({
  showModal,
  setShowModal,
  userData = {},
  parentBoardId = null,
}) {
  const [boardName, setBoardName] = useState(userData?.boardName || '');
  const [boardAddress, setBoardAddress] = useState(
    userData?.boardAddress || ''
  );
  const [boardDescription, setBoardDescription] = useState(
    userData?.boardDescription || ''
  );
  const [iconFile, setIconFile] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [category, setCategory] = useState('일반');

  const [readPermission, setReadPermission] = useState(false);
  const [writePermission, setWritePermission] = useState(false);
  const [commentPermission, setCommentPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [adminOnly, setAdminOnly] = useState(false);
  const [memberOnly, setMemberOnly] = useState(false);
  const [email, setEmail] = useState(
    userData?.email || 'fkawnlTjsej123@gmail.com'
  );
  const [cardNewsCount, setCardNewsCount] = useState(
    userData?.cardNewsCount || '0'
  );
  const [membership, setMembership] = useState(
    userData?.membership || '브론즈'
  );

  const [viewReadStage1, setViewReadStage1] = useState({
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [viewReadStage2, setViewReadStage2] = useState({
    level0: false,
    level1: false,
    level2: false,
    level3: false,
    level4: false,
    level5: false,
    level6: false,
    manager: false,
    admin: false,
    master: false,
  });

  const [writePostStage1, setWritePostStage1] = useState({
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [writePostStage2, setWritePostStage2] = useState({
    level0: false,
    level1: false,
    level2: false,
    level3: false,
    level4: false,
    level5: false,
    level6: false,
    manager: false,
    admin: false,
    master: false,
  });

  const [writeCommentStage1, setWriteCommentStage1] = useState({
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5: false,
    termNnn: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [writeCommentStage2, setWriteCommentStage2] = useState({
    level0: false,
    level1: false,
    level2: false,
    level3: false,
    level4: false,
    level5: false,
    level6: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [managerPermission, setManagerPermission] = useState(
    userData?.managerPermission || false
  );
  const [fullTimeManagerPermission, setFullTimeManagerPermission] = useState(
    userData?.fullTimeManagerPermission || true
  );
  const [accountDeactivate, setAccountDeactivate] = useState(
    userData?.accountDeactivate || false
  );
  const [selectedFile, setSelectedFile] = useState(null);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxWidth: '90vw',
    bgcolor: '#FFFFFF',
    borderRadius: '18px',
    boxShadow: 24,
    maxHeight: '90vh',
    overflowY: 'auto',
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
    }
  };

  const handleSubmit = () => {
    console.log({
      boardName,
      boardAddress,
      boardDescription,
      iconFile,
      bannerFile,
      category,
      readPermission,
      writePermission,
      commentPermission,
      deletePermission,
      adminOnly,
      memberOnly,
      email,
      cardNewsCount,
      membership,
      viewReadStage1,
      viewReadStage2,
      writePostStage1,
      writePostStage2,
      writeCommentStage1,
      writeCommentStage2,
      managerPermission,
      fullTimeManagerPermission,
      accountDeactivate,
      selectedFile,
      parentBoardId,
    });
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      aria-labelledby="user-edit-modal"
      aria-describedby="user-edit-modal-description"
    >
      <Box sx={modalStyle}>
        {/* Header */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1.5,
            px: 4,
            borderBottom: '1px solid #F0F2F5',
            backgroundColor: '#FFFFFF',
            zIndex: 10,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              onClick={() => setShowModal(false)}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ChevronLeft size={24} color="#000000" />
            </Box>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 600,
                color: '#000000',
              }}
            >
              {parentBoardId ? '하위 게시판 만들기' : '새 게시판 만들기'}
            </Typography>
          </Box>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              backgroundColor: '#3366FF',
              color: '#FFFFFF',
              height: 40,
              px: 3,
              borderRadius: 1.5,
              fontSize: 15,
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#2952CC',
                boxShadow: 'none',
              },
            }}
          >
            저장
          </Button>
        </Box>

        <Box sx={{ px: 4, pb: 4, pt: 3 }}>
          <Grid container spacing={3}>
            {/* 게시판 이름 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 0.5,
                }}
              >
                게시판 이름 <span style={{ color: '#FF0000' }}>*</span>
              </Typography>
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#999999',
                  mb: 1,
                }}
              >
                예 : 공지사항, 자유게시판
              </Typography>
              <AppTextField
                fullWidth
                name="boardName"
                placeholder="게시판 이름을 입력해 주세요"
                value={boardName}
                onChange={e => setBoardName(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 게시판 주소 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 0.5,
                }}
              >
                게시판 주소 <span style={{ color: '#FF0000' }}>*</span>
              </Typography>
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#999999',
                  mb: 1,
                }}
              >
                예 : notice, free-board (영문, 숫자, 하이픈만 사용)
              </Typography>
              <AppTextField
                fullWidth
                name="boardAddress"
                placeholder="게시판 주소를 입력해 주세요"
                value={boardAddress}
                onChange={e => setBoardAddress(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 게시판 설명 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 0.5,
                }}
              >
                게시판 설명
              </Typography>
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#999999',
                  mb: 1,
                }}
              >
                게시판에 대한 간단한 설명을 입력하세요.
              </Typography>
              <AppTextField
                fullWidth
                name="boardDescription"
                placeholder="게시판 설명을 입력해 주세요"
                value={boardDescription}
                onChange={e => setBoardDescription(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 이미지 설정 */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* 아이콘 설정 */}
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    아이콘 설정
                  </Typography>
                  <Box
                    component="label"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#F0F2F5',
                      borderRadius: '12px',
                      padding: iconFile ? '0' : '40px 20px',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      height: '150px',
                      position: 'relative',
                      overflow: 'hidden',
                      '&:hover': {
                        backgroundColor: iconFile ? 'transparent' : '#E8EAED',
                        '&::after': iconFile
                          ? {
                              content: '""',
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            }
                          : {},
                      },
                    }}
                  >
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={e => setIconFile(e.target.files[0])}
                    />
                    {iconFile ? (
                      <Box
                        component="img"
                        src={URL.createObjectURL(iconFile)}
                        alt="Icon preview"
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    ) : (
                      <>
                        <Camera size={32} color="#9CA3AF" strokeWidth={1.5} />
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#9CA3AF',
                            mt: 1.5,
                            textAlign: 'center',
                          }}
                        >
                          클릭하여 파일 선택
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 13,
                            color: '#9CA3AF',
                            mt: 0.5,
                            textAlign: 'center',
                          }}
                        >
                          (정사각형 사이즈)
                        </Typography>
                      </>
                    )}
                  </Box>
                </Grid>

                {/* 배너 이미지 설정 */}
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    배너 이미지 설정
                  </Typography>
                  <Box
                    component="label"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#F0F2F5',
                      borderRadius: '12px',
                      padding: bannerFile ? '0' : '40px 20px',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      height: '150px',
                      position: 'relative',
                      overflow: 'hidden',
                      '&:hover': {
                        backgroundColor: bannerFile ? 'transparent' : '#E8EAED',
                        '&::after': bannerFile
                          ? {
                              content: '""',
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            }
                          : {},
                      },
                    }}
                  >
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={e => setBannerFile(e.target.files[0])}
                    />
                    {bannerFile ? (
                      <Box
                        component="img"
                        src={URL.createObjectURL(bannerFile)}
                        alt="Banner preview"
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    ) : (
                      <>
                        <Camera size={32} color="#9CA3AF" strokeWidth={1.5} />
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#9CA3AF',
                            mt: 1.5,
                            textAlign: 'center',
                          }}
                        >
                          클릭하여 파일 선택
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 13,
                            color: '#9CA3AF',
                            mt: 0.5,
                            textAlign: 'center',
                          }}
                        >
                          (3:4 사이즈)
                        </Typography>
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            {/* 카테고리 설정 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1.5,
                }}
              >
                카테고리
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: '#F0F2F5',
                  borderRadius: '12px',
                  padding: '14px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#E8EAED',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    color: '#333333',
                    fontWeight: 400,
                  }}
                >
                  {category}
                </Typography>
                <ChevronDown size={20} color="#9CA3AF" strokeWidth={1.5} />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 2,
                }}
              >
                권한 설정
              </Typography>

              {/* 권한 체크박스 */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 3,
                  flexWrap: 'wrap',
                  mb: 4,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setReadPermission(!readPermission)}
                >
                  <Checkbox
                    checked={readPermission}
                    onChange={e => setReadPermission(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    읽기 권한
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setWritePermission(!writePermission)}
                >
                  <Checkbox
                    checked={writePermission}
                    onChange={e => setWritePermission(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    쓰기 권한
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setCommentPermission(!commentPermission)}
                >
                  <Checkbox
                    checked={commentPermission}
                    onChange={e => setCommentPermission(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    댓글 권한
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setDeletePermission(!deletePermission)}
                >
                  <Checkbox
                    checked={deletePermission}
                    onChange={e => setDeletePermission(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    삭제 권한
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setAdminOnly(!adminOnly)}
                >
                  <Checkbox
                    checked={adminOnly}
                    onChange={e => setAdminOnly(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    관리자 전용
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setMemberOnly(!memberOnly)}
                >
                  <Checkbox
                    checked={memberOnly}
                    onChange={e => setMemberOnly(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    회원 전용
                  </Typography>
                </Box>
              </Box>

              {/* 1. 글보기 멤버쉽 권한 */}
              <Box sx={{ mb: 4 }}>
                {/* 글보기 멤버쉽 권한 1단계 */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글보기 멤버쉽 권한 1단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'all', label: '전체' },
                      { key: 'term1', label: '1기' },
                      { key: 'term2', label: '2기' },
                      { key: 'term3', label: '3기' },
                      { key: 'term4', label: '4기' },
                      { key: 'term5', label: '5기' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setViewReadStage1(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={viewReadStage1[item.key]}
                          onChange={e =>
                            setViewReadStage1(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* 글보기 멤버쉽 권한 2단계 */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글보기 멤버쉽 권한 2단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'level0', label: '레벨0' },
                      { key: 'level1', label: '레벨1' },
                      { key: 'level2', label: '레벨2' },
                      { key: 'level3', label: '레벨3' },
                      { key: 'level4', label: '레벨4' },
                      { key: 'level5', label: '레벨5' },
                      { key: 'level6', label: '레벨6' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setViewReadStage2(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={viewReadStage2[item.key]}
                          onChange={e =>
                            setViewReadStage2(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* 2. 글쓰기 멤버쉽 권한 */}
              <Box sx={{ mb: 4 }}>
                <Box
                  sx={{
                    height: '1px',
                    backgroundColor: '#E0E0E0',
                    mb: 3,
                  }}
                />

                {/* 글쓰기 멤버쉽 권한 1단계 */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글쓰기 멤버쉽 권한 1단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'all', label: '전체' },
                      { key: 'term1', label: '1기' },
                      { key: 'term2', label: '2기' },
                      { key: 'term3', label: '3기' },
                      { key: 'term4', label: '4기' },
                      { key: 'term5', label: '5기' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWritePostStage1(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writePostStage1[item.key]}
                          onChange={e =>
                            setWritePostStage1(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* 글쓰기 멤버쉽 권한 2단계 */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글쓰기 멤버쉽 권한 2단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'level0', label: '레벨0' },
                      { key: 'level1', label: '레벨1' },
                      { key: 'level2', label: '레벨2' },
                      { key: 'level3', label: '레벨3' },
                      { key: 'level4', label: '레벨4' },
                      { key: 'level5', label: '레벨5' },
                      { key: 'level6', label: '레벨6' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWritePostStage2(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writePostStage2[item.key]}
                          onChange={e =>
                            setWritePostStage2(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* 3. 댓글 쓰기 멤버쉽 권한 */}
              <Box>
                <Box
                  sx={{
                    height: '1px',
                    backgroundColor: '#E0E0E0',
                    mb: 3,
                  }}
                />

                {/* 댓글 쓰기 멤버쉽 권한 1단계 */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    댓글 쓰기 멤버쉽 권한 1단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'all', label: '전체' },
                      { key: 'term1', label: '1기' },
                      { key: 'term2', label: '2기' },
                      { key: 'term3', label: '3기' },
                      { key: 'term4', label: '4기' },
                      { key: 'term5', label: '5기' },
                      { key: 'termNnn', label: 'nnn기' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWriteCommentStage1(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writeCommentStage1[item.key]}
                          onChange={e =>
                            setWriteCommentStage1(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* 댓글 쓰기 멤버쉽 권한 2단계 */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    댓글 쓰기 멤버쉽 권한 2단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'level0', label: '레벨0' },
                      { key: 'level1', label: '레벨1' },
                      { key: 'level2', label: '레벨2' },
                      { key: 'level3', label: '레벨3' },
                      { key: 'level4', label: '레벨4' },
                      { key: 'level5', label: '레벨5' },
                      { key: 'level6', label: '레벨6' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWriteCommentStage2(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writeCommentStage2[item.key]}
                          onChange={e =>
                            setWriteCommentStage2(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
}
